import type { SelectOption } from '@melt-ui/svelte';
import { match } from 'ts-pattern';
import type { SearchHeaderFormData_ProfileContentEnum } from '$gql/graphql';
import { searchHeaderFormData_ProfileContentEnumValues } from '$gql/zod-generated';
import type { Choice } from '$components/Form/PrettyMultiChoice.svelte';

export type Value = SearchHeaderFormData_ProfileContentEnum;

export const values = searchHeaderFormData_ProfileContentEnumValues;

export function valueToLabel(value: Value): string {
    return match(value)
        .with('with_cv', () => 'Avec un CV')
        .with('with_experiences', () => 'Avec expériences')
        .with('with_formations', () => 'Avec formations')
        .with('with_video', () => 'Avec vidéo')
        .exhaustive();
}

export const selectOptions: readonly SelectOption<Value>[] = values.map(valueToOption);

export const prettyChoices: readonly Choice<Value>[] = values.map((value) => {
    return {
        value,
        key: value,
        label: valueToLabel(value),
    };
});

export function valueToOption(value: Value): SelectOption<Value> {
    return {
        value,
        label: valueToLabel(value),
    };
}
